// const CryptoJS = require("crypto-js");
import CryptoJS from "crypto-js";

function GetRandomNum(n) {
  let chars = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    ".",
    "?",
    "~",
    "!",
    "@",
    "#",
    "$",
    "%",
    "^",
    "&",
    "*",
  ];
  if (n == null) {
    n = 16;
  }
  let res = "";
  for (let i = 0; i < n; i++) {
    let id = Math.ceil(Math.random() * 46);
    res += chars[id];
  }
  return res;
}

function GetUuid() {
  let s = [];
  const hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
    let indexStart = Math.floor(Math.random() * 0x10);
    s[i] = hexDigits.substring(indexStart, indexStart + 1);
  }
  s[14] = "4";
  let indexStart = (s[19] & 0x3) | 0x8;
  s[19] = hexDigits.substring(indexStart, indexStart + 1);
  s[8] = s[13] = s[18] = s[23] = "-";
  return s.join("");
}

function Decrypt(word, key, iv) {
  let key2 = CryptoJS.enc.Utf8.parse(key);
  let iv2 = CryptoJS.enc.Utf8.parse(iv);

  let base64 = CryptoJS.enc.Base64.parse(word);
  let src = CryptoJS.enc.Base64.stringify(base64);
  var decrypt = CryptoJS.AES.decrypt(src, key2, {
    iv: iv2,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

function Encrypt(word, key, iv) {
  let key2 = CryptoJS.enc.Utf8.parse(key);
  let iv2 = CryptoJS.enc.Utf8.parse(iv);
  let src = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(src, key2, {
    iv: iv2,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

export default {
  Decrypt,
  Encrypt,
  GetRandomNum,
  GetUuid,
};



// WEBPACK FOOTER //
// ./src/utils/aesUtils.js